import ToggleButton from "@mui/material/ToggleButton"
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup"
import { useEffect, useState } from "react"

const Switcher = ({
    items,
    onSelect,
    selected,
    disabled,
    disabledItems = []
}) => {
    const [selectedItem, setSelectedItem] = useState(selected.value)

    useEffect(() => {
        setSelectedItem(selected.value)
    }, [])

    const handleChange = (event, value) => {
        if (!value) return
        setSelectedItem(value)

        onSelect(value)
    }

    return (
        <ToggleButtonGroup
            value={selectedItem}
            exclusive
            onChange={handleChange}
            aria-label='Platform'
            disabled={disabled}>
            {items.map(({ label, value, superText }, key) => {
                let tourClass = ""
                if (value.toLowerCase().includes("price"))
                    tourClass = "tour-sentiment-plus-btn"
                else if (value.toLowerCase().includes("sentiment"))
                    tourClass = "tour-sentiment-btn"

                const isDisabled = disabledItems.includes(value)

                return (
                    <ToggleButton
                        key={key}
                        value={value}
                        disabled={isDisabled}
                        className={`${
                            value === selectedItem && "text-white"
                        } ${tourClass}`}
                        style={{
                            padding: "0.5rem",
                            borderRadius: "5px",
                            backgroundColor:
                                value === selectedItem && "#e87b0e",
                            border: "1px solid #dbdbdb",
                            fontSize: "0.9rem",
                            opacity: isDisabled ? 0.5 : 1,
                            cursor: isDisabled ? "not-allowed" : "pointer"
                        }}>
                        {label}
                        {superText && (
                            <sup className='font-md text-2xl'>{superText}</sup>
                        )}
                    </ToggleButton>
                )
            })}
        </ToggleButtonGroup>
    )
}

export default Switcher
